import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { generalCreators } from './redux/general/general-action';
import { GENERAL_STATE_KEY } from './redux/general/general-reducer';
import { MODAL_TYPE } from './redux/general/general-constant';

export const Init: React.FC<Props> = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(generalCreators.InitialLoad());
    window.addEventListener('popstate', clearStateModal);
    return () => window.removeEventListener('popstate', clearStateModal);
  }, [clearStateModal]);

  function clearStateModal() {
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.MODAL, { visible: false, onOk: () => { }, type: MODAL_TYPE.BLANK }));
    dispatch(generalCreators.setGeneralState(GENERAL_STATE_KEY.TNC_MODAL, { visible: false, contentHtml: undefined }));
  }

  return (
    null
  );
};

type Props = {};
